export default "__VITE_ASSET__CCmhUEDN__"